import { registerModuleDataProvider } from '../../../providers/CustomDataProvider';
import { Resources } from '../../resource';
import { settlementCyclesDataProvider } from './dataProvider';

export function initSocialTradingSettlementCyclesDataProvider() {
  registerModuleDataProvider(Resources.socialTradingSettlementCycles, settlementCyclesDataProvider);
}

initSocialTradingSettlementCyclesDataProvider();
